export default {
  PERSONAL: 'personal',
  TEAM: 'team',
  WORKING_MODE: 'working-mode',
  VIEWER: 'viewer',
  EDITOR: 'editor',
  ADMIN: 'admin',
  OWNER: 'owner',
}
